import { type GridColDef, type GridRenderCellParams } from "@mui/x-data-grid-pro";

import { Group } from "@/components/global/types";

import CoAppDataGridListCell from "../../../global/components/datagrid/CoAppDataGridListCell";
import CoAppDataGridNameCell from "../../../global/components/datagrid/CoAppDataGridNameCell";
import RowActionIcons from "../../../global/components/RowActionIcons";

export interface GroupManagementColumnsProps {
  openResourceEditPage: (
	params: Record<string, unknown>,
	navIndex: number,
	resourceName: string
  ) => void;
  navigationItemReferences: { groupNavItemIndex: number } & Record<string, number>;
  duplicateGroup: (groupId: string) => void;
  handleToggleGroupDeleteDialog: (group: Group) => void;
  identityProviderName: string | null;
  organizationSsoAndScim: boolean;
}

export const groupColumns = ["name", "userCount", "ruleCount", "plugins", "actions"];
export const ssoAndScimEnabledGroupColumns = ["name", "userCount", "ruleCount", "idpgroups", "plugins", "actions"];

export default function GroupManagementColumns({
	openResourceEditPage,
	navigationItemReferences,
	duplicateGroup,
	handleToggleGroupDeleteDialog,
	identityProviderName,
	organizationSsoAndScim,
}: GroupManagementColumnsProps): GridColDef<Group>[] {
	return [
		{
			field: "name",
			headerName: "Name",
			sortable: true,
			editable: false,
			flex: 0.5,
			renderCell: (params: GridRenderCellParams<Group>) => (
				<CoAppDataGridNameCell item={params.row} />
			),
		},
		{
			field: "userCount",
			headerName: "Total Users",
			editable: false,
			sortable: false,
			flex: 0.5,
			renderCell: (params: GridRenderCellParams<Group>) => (
				<CoAppDataGridNameCell item={params.value} />
			),
		},
		{
			field: "ruleCount",
			headerName: "Total Rules",
			editable: false,
			sortable: false,
			flex: 0.5,
			renderCell: (params: GridRenderCellParams<Group>) => (
				<CoAppDataGridNameCell item={params.value} />
			),
		},
		{
			field: "plugins",
			headerName: "Plugins",
			editable: false,
			sortable: false,
			flex: 1,
			renderCell: (params: GridRenderCellParams<Group>) => (
				<CoAppDataGridListCell items={params.value.filter(plugin => plugin.active)} resource="Plugins" />
			),
		},
		...(organizationSsoAndScim
			? [
				{
					field: "idpgroups",
					headerName: identityProviderName ? `${identityProviderName} Groups` : "Groups",
					editable: false,
					sortable: false,
					flex: 1,
					renderCell: (params: GridRenderCellParams<Group>) => (
						<CoAppDataGridListCell
									items={params.value}
									resource={identityProviderName ? `${identityProviderName} Groups` : "Groups"}
								/>
					),
				},
			]
			: []),
		{
			field: "actions",
			type: "actions",
			sortable: false,
			filterable: false,
			hideable: false,
			headerName: "",
			width: 130,
			align: "right",
			headerAlign: "right",
			renderCell: (params: GridRenderCellParams<Group>) => (
				<RowActionIcons
							onEdit={() => {
								openResourceEditPage(
                  params as unknown as Record<string, unknown>,
                  navigationItemReferences.groupNavItemIndex,
                  "Groups",
								);
							}}
							onDuplicate={() => {
								duplicateGroup(params.row?.id || "");
							}}
							onDelete={() => {
								handleToggleGroupDeleteDialog(params.row || null);
							}}
						/>
			),
		},
	];
}